module.exports = __webpack_public_path__ + "static/media/whistle.6aee09a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/whistle.svg
// module id = 209
// module chunks = 0